export const SUBSCRIPTION_ACTIVE_STATUS = 'active';
export const SUBSCRIPTION_PAST_DUE_STATUS = 'pastDue';
export const SUBSCRIPTION_UNDER_NOTICE_STATUS = 'underNotice';
export const SUBSCRIPTION_CANCELLED_STATUS = 'cancelled';
